import { setNotificationSetupCookie } from "../../Helpers/NotificationsHelper";

export const UPDATE_NOTIFICATIONS = "UPDATE_NOTIFICATIONS";

export const finishNotificationsSetup = () => dispatch => {
  setNotificationSetupCookie();
  dispatch({ type: UPDATE_NOTIFICATIONS, response: { isSetup: true } });
};
